module.exports = __webpack_public_path__ + "static/media/c1.d2b5333e.jpg";